<template>
    <div class="trusted-ratings mt-4">
        <template v-if="singleReview">
            <div class="trusted-top">
                <div class="comment-container">
                    <div>
                        <blockquote class="fade-rating">
                            <p v-html="singleReview.review.comment"></p>
                            <cite>
                                <span v-html="singleReview.orderAddresses[0].name1"></span>
                                <br>
                                <span class="font-weight-normal"> aus <span v-html="singleReview.orderAddresses[0].town"></span></span>
                            </cite>
                        </blockquote>
                    </div>
                </div>
            </div>
            <div class="trusted-bottom">
                <lazy-img
                        :image-url="'/layout/od_servershop24_v1_10/images/trusted-shops.png'"
                        :alt="'Trusted Shops'"
                        :title="'Trusted Shops'"
                        class="mr-2">
                </lazy-img>
              {{ $translate("Servershop5::Template.111TrustedshopsNote") }}  / <span>5.00</span> aus <span> {{ $translate("Servershop5::Template.111TrustedshopsTotalRatings") }} </span> {{ $translate("Servershop5::Template.Bewertungen") }}
<!--                <span v-html="globalscore"></span> / 5.00 aus <span v-html="reviewCount"></span> Bewertungen-->
            </div>
        </template>
    </div>
</template>

<script>
    export default
    {
        props: ["template","data"],
        data: function()
        {
            return {
                reviews: [],
                globalscore:0,
                singleReview:'',
                reviewCount:0
            };
        },
        mounted: function()
        {
            var _self = this;
            _self.getData();
        },
        methods:
            {
                getData: function()
                {
                    let _self = this;

                    _self.reviews = this.data.trusted_reviews;
                    _self.globalscore = parseFloat(this.data.trusted_overallMark).toFixed(2);
                    _self.singleReview = this.data.trusted_reviews[0];
                    _self.reviewCount = this.data.trusted_totalReviewCount;

                    _self.pollData();
                },
                pollData: function()
                {
                    let _self = this;
                    let i = 0;
                    let count = setInterval(() =>
                    {
                        i++;
                        _self.singleReview = _self.reviews[i];
                        if(i==4)
                        {
                            clearInterval(count);
                            i = 0;
                            _self.pollData();
                        }
                    }, 10000)

                }
            },
        created: function created()
        {
            var _self = this;
            return _self.singleReview;
        }
    }
</script>
